"use client";

import React, { type FC, type PropsWithChildren } from "react";

interface IProps extends PropsWithChildren {
  onSubmit: (e?: React.BaseSyntheticEvent) => Promise<void>;
  className?: string;
}

const FormWrapper: FC<IProps> = ({
  onSubmit,
  children,
  className = "space-y-5",
}) => (
  <form
    className={className}
    onSubmit={onSubmit}
  >
    {children}
  </form>
);

export default FormWrapper;
